import { render } from "./MyProfile.vue?vue&type=template&id=0b389700&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=0b389700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b389700"]])

export default __exports__